import React, { useState, useEffect } from 'react';

const ScreeningInfo = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentFilm, setCurrentFilm] = useState('편안한 밤');

  const films = {
    '편안한 밤': {
      stills: [
        'https://ifh.cc/g/qzNssF.jpg', // 변경된 부분
        'https://ifh.cc/g/aRk6BO.jpg', // 변경된 부분
        'https://ifh.cc/g/WCM0JP.jpg'  // 변경된 부분
      ],
      title: '이준용 작품소개: <편안한 밤>',
      year: '2018년 다큐멘터리, 20분 19초',
      synopsis: '재개발이 한창인 2018년 서울 장위동 장위7구역. 그곳에는 마지막 남은 철거민 조한정씨가 살고 있다. 강제집행을 하루 앞둔 밤, 조한정씨는 담담하게 자신의 집과 동네에 얽힌 자신의 이야기를 들려준다.',
      direction: '사라지는 공간에 카메라를 세워놓고, 그곳의 마지막을 기록하는 일은 다큐멘터리만이 할 수 있는 일이라고 생각합니다. 김동원이 그랬고, 왕빙이 그랬습니다. 2018년 어느 봄날, 우리는 주인공과 함께 장위7구역의 마지막을 지켜 보았습니다. 더 꼼꼼히 기록하지 못하고, 더 힘차게 싸우지 못한 것이 아쉬울 뿐입니다.' // 추가된 부분
    },
    '관': {
      stills: [
        'https://ifh.cc/g/BNJNtR.jpg', // 변경된 부분
        'https://ifh.cc/g/dbZn4l.jpg', // 변경된 부분
        'https://ifh.cc/g/nMk2mX.jpg'  // 변경된 부분
      ],
      title: '류승진 작품소개: <관>',
      year: '2023년 다큐멘터리, 15분 24초',
      synopsis: '1980년 5월, 광주. 계엄군의 무력 진압에 사망자가 속출하자 광주 시내에는 시신을 담을 관이 부족해진다. 19세 여학생 박현숙은 시민군과 함께 버스를 타고 광주를 빠져나가 화순으로 관을 구하러 간다...',
      direction: '이 작품은 5.18 광주 민주화 운동 당시 \'주남마을 버스 총격 사건\'으로 사망한 고 박현숙 님의 시점에서 만들어진 가상의 기록 필름이다. 옛 전남도청으로 대표되는 광주 시내에서의 참상 외에도 아직 진실이 밝혀지지 않은 민간인 학살이 광주와 인근 곳곳에 감추어져 있다. 작품은 \'이야기되지 않은 죽음\'과 \'지금의 광주\'를 내레이션과 영상으로 교차시켜 과거와 현재를 직조함으로써 지금의 대한민국을 가능케 한 삶과 죽음을 전면에 드러내고자 했다. 이것은 집으로 돌아가지 못한 이들을 위한 집, 관에 대한 이야기이다.' // 추가된 부분
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % films[currentFilm].stills.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [currentFilm]);

  const renderFilmInfo = (film) => (
    <section className="mb-12">
      <h2 className="text-3xl font-subtitle text-acid-green mb-6">{films[film].title}</h2>
      <p className="text-xl text-neon-pink mb-4">{films[film].year}</p>
      <div className="relative h-64 mb-6">
        {films[film].stills.map((still, index) => (
          <img
            key={index}
            src={still}
            alt={`${film} 스틸 ${index + 1}`}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-500 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
      </div>
      <p className="text-white leading-relaxed font-semibold">{films[film].synopsis}</p> {/* 시놉시스 강조 */}
      <p className="text-white leading-relaxed italic mt-4">{films[film].direction}</p> {/* 연출의도 강조 */}
    </section>
  );

  return (
    <div className="max-w-4xl mx-auto p-6 bg-purple-900 bg-opacity-20 rounded-lg shadow-lg">
      <header className="text-center mb-10 pt-4">
        <h1 className="text-5xl font-bold gradient-text mb-4 leading-tight flex items-center justify-center">
          <span className="mr-4 text-4xl">🎬</span> {/* 왼쪽 이모티콘 */}
          천지개벽 다큐멘터리 상영회
          <span className="ml-4 text-4xl">📹</span> {/* 오른쪽 이모티콘 */}
        </h1>
        <p className="text-2xl text-neon-pink">2024년 10월 3일 오후 2시</p>
        <p className="text-xl text-electric-blue">영화 중심 극장 작은극장</p>
      </header>

      <section className="mb-12">
        <h2 className="text-3xl font-subtitle text-acid-green mb-6">행사 순서 및 예상 러닝타임</h2>
        <ul className="space-y-4">
          {[ 
            { time: "14:00 - 14:05", event: "오프닝 및 소개" },
            { time: "14:05 - 14:40", event: "관 / 편안한밤 상영 (35분)" },
            { time: "14:40 - 15:00", event: "토크 (15~20분)" },
            { time: "15:00 - 15:05", event: "트레일러 상영: <캥거루가족> / <다큐멘터리 손선이>" },
            { time: "15:05 - 15:15", event: "토크 및 마무리" },
          ].map((item, index) => (
            <li key={index} className="flex items-center">
              <span className="w-32 text-neon-pink font-subtitle">{item.time}</span>
              <span className="flex-1 text-white">{item.event}</span>
            </li>
          ))}
        </ul>
      </section>

      <div className="section-divider"></div>

      {renderFilmInfo('편안한 밤')}

      <div className="section-divider"></div>

      {renderFilmInfo('관')}

      <button 
        className="btn-primary w-full text-xl" 
        onClick={() => {
          const ticketInfoSection = document.getElementById('tickets');
          if (ticketInfoSection) {
            ticketInfoSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      >
        상영회 참가 신청
      </button>
    </div>
  );
};

export default ScreeningInfo;